const stores = document.getElementById('js-stores')

if (stores) {
  const styles = [
    {
      featureType: 'all',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'all',
      elementType: 'labels.icon',
      stylers: [
        {
          visibility: 'off',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#f1efe8',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
        {
          gamma: '1.19',
        },
      ],
    },
    {
      featureType: 'landscape.man_made',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
        {
          gamma: '0.00',
        },
        {
          weight: '2.07',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#b2ac83',
        },
      ],
    },
    {
      featureType: 'road.highway',
      elementType: 'geometry.stroke',
      stylers: [
        {
          color: '#b2ac83',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'geometry.fill',
      stylers: [
        {
          color: '#8ac0c4',
        },
      ],
    },
  ]

  new Vue({
    el: '#js-stores',
    data() {
      return {
        stores: [],
        shops: [],
        query: '',
        map: null,
        markers: [],
        infowindow: null,
      }
    },
    mounted() {
      this.loadMap()
    },
    methods: {
      generateInfoWindow(shop) {
        return new google.maps.InfoWindow({
          content: `<div class="landing-page__map-info">
            <b>${shop.store}</b>
            <p>${shop.address}</p>
            <p>${shop.address2}</p>
            <p>${shop.city} ${shop.zip}</p>
            <p>${shop.country}</p>
        </div>`,
        })
      },

      focusInput() {
        const y =
          this.$refs.input.getBoundingClientRect().top +
          window.pageYOffset +
          -180

        window.scrollTo({ top: y, behavior: 'smooth' })
      },

      loadMap() {
        if (!document.getElementById('store-map')) {
          return
        }

        var id = '1KU9_-YnpSBxqxbGI7YyVB2FDKRSRGTpwQ8w_bJxRduY'
        var gid = '0'
        var url =
          'https://docs.google.com/spreadsheets/d/' +
          id +
          '/gviz/tq?tqx=out:json&tq&gid=' +
          gid

        var oReq = new XMLHttpRequest()
        oReq.open('get', url, true)
        oReq.send()

        var app = this

        function reqListener() {
          var jsonString = this.responseText.match(
            /google\.visualization\.Query\.setResponse\(([\s\S\w]+)\)/
          )

          if (jsonString && jsonString.length == 2) {
            var json = JSON.parse(jsonString[1]).table

            var rows = json.rows

            for (var r = 0; r < rows.length; r++) {
              var rowData = rows[r]['c']

              if (r !== 0 && rowData !=  null) {
                const item = {
                  id: r,
                  store: rowData[0] ? rowData[0]['v'] : '',
                  address: rowData[1] ? rowData[1]['v'] : '',
                  city: rowData[2] ? rowData[2]['v'] : '',
                  zip: rowData[3] ? rowData[3]['v'] : '',
                  country: rowData[4] ? rowData[4]['v'] : '',
                  lat: rowData[5] ? rowData[5]['v'] : '',
                  lng: rowData[6] ? rowData[6]['v'] : '',
                  address2: rowData[7] ? rowData[7]['v'] || '' : '',
                }

                app.stores.push(item)
              }
              rowData = []
            }

            app.generateMap()
          }
        }
        oReq.onload = reqListener
      },

      generateMap() {
        var mapOptions = {
          disableDefaultUI: true,
          zoomControl: true,
          styles,
        }

        this.map = new google.maps.Map(
          document.getElementById('store-map'),
          mapOptions
        )

        var latlngbounds = new google.maps.LatLngBounds()

        this.stores.map((shop) => {
          if (!shop.lat || !shop.lng) {
            return null
          }

          var latLng = new google.maps.LatLng(
            parseFloat(shop.lat),
            parseFloat(shop.lng)
          )

          latlngbounds.extend(latLng)

          var marker = new google.maps.Marker({
            position: latLng,
            map: this.map,
            id: shop.id,
            title: shop.store,
            animation: google.maps.Animation.DROP,
          })

          marker.addListener('click', () => {
            this.openWindow(shop, marker)
          })

          this.markers.push(marker)
        })

        this.map.fitBounds(latlngbounds)
      },

      openWindow(shop, marker) {
        if (this.infowindow) {
          this.infowindow.close()
        }

        this.infowindow = this.generateInfoWindow(shop)
        this.infowindow.open(this.map, marker)
      },

      goToLocation(id) {
        window.scrollTo({ top: 0, behavior: 'smooth' })

        const marker = this.markers.find((item) => item.id === id)

        const shop = this.stores.find((item) => item.id === id)

        this.openWindow(shop, marker)
        this.map.panTo(marker.position)
        this.map.setZoom(12)
      },
    },
    computed: {
      results() {
        if (!this.query) {
          return []
        } else {
          return this.stores.filter((o) =>
            Object.keys(o).some((k) => {
              if (typeof o[k] === 'string' || o[k] instanceof String) {
                return o[k].toLowerCase().includes(this.query.toLowerCase())
              } else {
                return false
              }
            })
          )
        }
      },
    },
  })
}
